import useLenis from "@/hooks/useLenis";
import { Toaster } from "@/components/ui/sonner";
import { GrainOverlay } from "@/components/GrainOverlay";
import { Navigation } from "@/components/Navigation";
import { Hero } from "@/components/Hero";
import { Manifesto } from "@/components/Manifesto";
import { WhyUs } from "@/components/WhyUs";
import { Process } from "@/components/Process";
import { Reviews } from "@/components/Reviews";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { WhatsAppButton } from "@/components/WhatsAppButton";

export default function HomePage() {
  useLenis();
  return (
    <>
      <GrainOverlay />
      <Navigation />
      <main>
        <Hero />
        <Manifesto />
        <WhyUs />
        <Process />
        <Reviews />
        <Contact />
      </main>
      <Footer />
      <WhatsAppButton />
      <Toaster position="bottom-right" />
    </>
  );
}
